import { loadStripe } from '@stripe/stripe-js';
import { captureMessage } from '@sentry/react';
import config from 'config';
import { ClientBillingInfo } from 'domains/billing/types';

 
enum StripeAccount {
  INC = 'acct_1EtnCNCVYcGP97qQ',
  SLP = 'acct_1GpjkLGN8gxeZoYX',
  TPC = 'acct_1Kl37qBo3FXyptOC',
  TNJ = 'acct_1Me37oB8eMFYF0iZ',
  STC = 'acct_1Me3AfHdsQhvtcty',
}

// it contains all stripe accounts publishable keys objects.
// as we have multiple stripe accounts, this is to avoid recreating the `Stripe` objects on every render.
const stripeAccounts = {
  [StripeAccount.INC]: loadStripe(config.get('stripePublishableKeyINC') as string),
  [StripeAccount.SLP]: loadStripe(config.get('stripePublishableKeySLP') as string),
  [StripeAccount.TPC]: loadStripe(config.get('stripePublishableKeyTPC') as string),
  [StripeAccount.TNJ]: loadStripe(config.get('stripePublishableKeyTNJ') as string),
  [StripeAccount.STC]: loadStripe(config.get('stripePublishableKeySTC') as string),
};

export const getStripeFromAccountID = async (stripeAccountID: string) => {
  const stripeAccount = await stripeAccounts[stripeAccountID as StripeAccount];
  if (!stripeAccount) {
    captureMessage(
      `Stripe account "${stripeAccountID}" does not exist. Please take a quick action to handle the new stripe account.`,
    );
  }
  return stripeAccount;
};

export const formatCreditCardExpireDate = (expirationMonth: number, expirationYear: number) => {
  return new Date(expirationYear, expirationMonth - 1).toISOString();
};

export const generateCardNumber = (brand: string, last4: string) => {
  return `${brand.toUpperCase()}···${last4}`;
};

/** Checks whether client is exempt from payments or not */
export const isExemptFromPayment = (info: ClientBillingInfo) => {
  if (info.billingType === 'self-pay') {
    return false;
  }

  if (info.billingType === 'insurance') {
    return info.exemptFromPatientResponsibility;
  }

  return false;
};
